<template>
    <div class="flex flex-col">
        <div class="flex flex-col">
            <h4 class="text-h4 py-[10px] ">{{ description.header }}</h4>
            <div class="text-3 mb-[45px] self-stretch " v-html="description.text"></div>
        </div> 
        <div class="">
            <img class="object-cover h-[120px] max-w-[270px]" v-for="image in description.images" :src="image.sizes.medium" :alt="description.header">
        </div>
    </div>
</template>
<script>
export default {
    name: 'DescriptionScrollView',
    props: {
        description: {},
    },
}
</script>